<div id="dsny-room"class="card card-info d-flex flex-row my-3 ">
  <div class="flex-column p-2 d-flex type-room">
    <span class="strong flex-column">
      <strong>Room Type</strong>
    </span>
    <span class="strong flex-column">{{room.roomType}}</span>
    <span class="strong pt-2">
      <strong>Type of bed</strong>
    </span>
    <span class="strong">A double bed</span>
  </div>
  <div class="flex-column p-2 d-flex max-people">
    <span class="strong">
      <strong>Capacity</strong>
    </span>
    <i class="icon icon-multiple-users-silhouette" aria-hidden="true"></i>
    <span class="strong">{{room.maxPax}} Person(s)</span>
  </div>
  <div class="flex-column p-2 d-flex rooms-price">
    <span class="strong">
      <strong>Price per night</strong>
    </span>
    <span class="strong">
      <strong>${{room['netPriceProf'] | number:'1.2-2'}}-</strong>
    </span>
    <span class="strong pt-2">
      <strong>{{room.optionNightsNetTotalProf}}Tarifa Neta</strong>
    </span>
    <span class="strong">
      <strong></strong>
    </span>
    <span class="strong">
      <strong>${{room.optionNightsNetTotalProf | number:'1.2-2'}}-</strong>
    </span>
  </div>
  <div class="flex-column p-2 d-flex options">
    <span class="strong">
      <strong>Options</strong>
    </span>
    <span aria-hidden="true">
      <i class="cr-icon fa fa-times"></i> Does not Include Meal Regime</span>
    <span aria-hidden="true">
      <i class="cr-icon fa fa-times"></i> You can not cancel or make changes</span>
  </div>
  <div class=" d-flex py-2 px-1  justify-content-center">
    <div class="btn-group" dropdown>
      <div class="form-group text-center px-2">
        <label for="elect-romms">
          <strong>Select</strong>
        </label>
        <div>
          <button type="button" class="btn-select" (click)="sendRoom(room)"><i class="{{selected === room? 'icon-dot-tripadvisor icon-selected' : 'icon-dot-tripadvisor-clean icon'}}" ></i></button>
        </div>
      </div>
    </div>
  </div>
</div>
